import React from 'react';
import cn from 'classnames';
import { observer } from 'mobx-react';

import { UIDAPresentationTypeEnum } from '@kaltura-ott/tvpil';

import DefaultModal from 'components/widgets/Modal/DefaultModal/DefaultModal';
import { ActionButtonTypesEnum } from 'interface';

import { pincodeLength, ValidatePin } from '../constants';

import PinCode from './PinCode/PinCode';
import { usePinCodeModalCombiner } from './hooks';
import { PinCodeModalTypes } from './PinCodeModalTypesEnum';

import styles from './PinCodeModal.module.scss';

export interface PinCodeModalProps {
  title?: string;
  className?: string;
  type: PinCodeModalTypes;
  isConfirmErrorMessage?: boolean;
  context?: UIDAPresentationTypeEnum;
  afterPinCodeContent?: React.ReactNode;
  beforePinCodeContent?: React.ReactNode;
  description?: string | React.ReactNode;
  validatePin: ValidatePin;
  callback?(success: boolean): void;
  onDecline?(): void;
}

function PinCodeModal({
  type,
  title,
  context,
  className,
  description,
  afterPinCodeContent,
  beforePinCodeContent,
  isConfirmErrorMessage = false,
  callback,
  onDecline,
  validatePin,
}: PinCodeModalProps) {
  const {
    error,
    pinCode,
    loading,
    pinTimeout,
    modalTitle,
    instruction,
    inputWrapper,
    pinLimitError,
    acceptButtonText,
    isPurchasePinLocked,
    submit,
    setError,
    setPinCode,
  } = usePinCodeModalCombiner({
    title,
    description,
    isConfirmErrorMessage,
    type,
    context,
    validatePin,
    callback,
  });

  return (
    <form onSubmit={submit}>
      <DefaultModal
        buttonProps={{
          acceptButtonText,
          acceptButtonType: ActionButtonTypesEnum.primary,
        }}
        className={className}
        loading={loading}
        onDecline={onDecline}
        title={modalTitle}
      >
        {beforePinCodeContent}
        <p className={cn(styles.instruction, { [styles.purchaseLock]: isPurchasePinLocked })}>{instruction}</p>
        <PinCode
          error={pinLimitError || error}
          inputWrapper={inputWrapper}
          loading={loading}
          pinCode={pinCode}
          pincodeLength={pincodeLength}
          setError={setError}
          setPinCode={setPinCode}
          pinTimeout={pinTimeout}
        />
        {afterPinCodeContent}
      </DefaultModal>
    </form>
  );
}

export default observer(PinCodeModal);
